module.exports = __webpack_public_path__ + "static/media/pause-calling.b8e55119.png";